import {
  CodeStepExecutionCacheMode,
  ExecutionType,
  TransformCachedCodeReuseScope,
  TransformCodeSourceMode,
} from '@/types/automationFields.ts';
import type { DecisionControlLogic } from '@/types/automationSteps.ts';

export const DEFAULT_DECISION_CONTROL_LOGIC: DecisionControlLogic = {
  execution_type: ExecutionType.AI,
  code_source_mode: TransformCodeSourceMode.GenerateAlways,
  cached_code_reuse_scope: TransformCachedCodeReuseScope.AcrossRuns,
  step_execution_cache_mode: CodeStepExecutionCacheMode.Automatic,
  provided_code: '',
};

export function makeDecisionControlLogic(
  overrides: Partial<DecisionControlLogic> = {},
): DecisionControlLogic {
  return { ...DEFAULT_DECISION_CONTROL_LOGIC, ...overrides };
}

export function getDecisionExecutionType(
  controlLogic?: Partial<DecisionControlLogic> | null,
): ExecutionType {
  return controlLogic?.execution_type ?? DEFAULT_DECISION_CONTROL_LOGIC.execution_type;
}

export function getDecisionCodeSourceMode(
  controlLogic?: Partial<DecisionControlLogic> | null,
): TransformCodeSourceMode {
  return controlLogic?.code_source_mode ?? DEFAULT_DECISION_CONTROL_LOGIC.code_source_mode;
}
